import { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl, CheckOrderPaymentStatus } from "../../BaseUrl/BaseUrl";
import "./Thankyou.css";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
const CheckPaymentStatus = () => {
  const { slug } = useParams();
  const [userId, modalName, merchantId, poojaBookingRemaining] =
    slug?.split("-") || [];

  const navigate = useNavigate();
  const [paymentData, setPaymentData] = useState(null);
  const [status, setStatus] = useState("loading"); // loading, failed, completed, pending, error
  const location = useLocation();

  useEffect(() => {
    if (!slug) return;

    const fetchPaymentStatus = async () => {
      try {
        const res = await axios.get(
          `${BaseUrl}/${CheckOrderPaymentStatus}/${slug}`
        );
        const data = res.data;

        if (data.state === "COMPLETED") {
          setStatus("completed");
          setPaymentData(data);

          if (modalName === "pujaBook") {
            const PujaBookingData = JSON.parse(
              localStorage.getItem("PujaBookingData")
            );

            const finalBookingData = {
              ...PujaBookingData,
              TRANSACTION_ID: data.transactionId || slug,
              TRANSACTION_STATUS: "Success",
              PAYMENT_STATUS: "Completed",
            };

            axios
              .post(`${BaseUrl}/BookPooja`, finalBookingData)
              .then((res) => {
                if (res?.data?.ID) {
                  localStorage.removeItem("PujaBookingData");
                }
              })
              .catch((err) => {
                console.error("Booking API Error:", err);
                alert("Booking failed after payment. Please contact support.");
              });
          } else if (modalName === "templeBooking") {
            const templeBookingData = JSON.parse(
              localStorage.getItem("templeBookingData")
            );

            const finalBookingData = {
              ...templeBookingData,
              TRANSACTION_ID: data.transactionId || slug,
              TRANSACTION_STATUS: "Success",
              PAYMENT_STATUS: "Completed",
            };

            axios
              .post(`${BaseUrl}/DarshanBook_Booking?TYPE`, finalBookingData)
              .then((res) => {
                if (res?.data?.ID) {
                  localStorage.removeItem("dailyPujaBookingData");
                }
              })
              .catch((err) => {
                console.error("Booking API Error:", err);
                alert("Booking failed after payment. Please contact support.");
              });
          }
          else if (modalName === "dailyPujaBooking") {
            const dailyPujaBookingData = JSON.parse(
              localStorage.getItem("dailyPujaBookingData")
            );

            const finalBookingData = {
              ...dailyPujaBookingData,
              TRANSACTION_ID: data.transactionId || slug,
              TRANSACTION_STATUS: "Success",
              PAYMENT_STATUS: "Completed",
            };

            axios
              .post(`${BaseUrl}/DailyPujaBook`, finalBookingData)
              .then((res) => {
                if (res?.data?.ID) {
                  localStorage.removeItem("dailyPujaBookingData");
                }
              })
              .catch((err) => {
                console.error("Booking API Error:", err);
                alert("Booking failed after payment. Please contact support.");
              });
          }
          // prasaad
          else if (modalName === "prasadBookingModal") {
            const PrasadPAYLOADData = JSON.parse(
              localStorage.getItem("prasadBooking")
            );

            const finalBookingData = {
              ...PrasadPAYLOADData,
              TRANSACTION_ID: data.transactionId || slug,
              TRANSACTION_STATUS: "Success",
              PAYMENT_STATUS: "Completed",
            };

            axios
              .post(`${BaseUrl}/Prasad/Prasad_Order`, finalBookingData)
              .then((res) => {
                if (res?.data?.ID) {
                  localStorage.removeItem("prasadBooking");
                  localStorage.setItem("cartItemCount", "0");
                  localStorage.setItem("cartItems", []);
                }
              })
              .catch((err) => {
                console.error("Booking API Error:", err);
                alert("Booking failed after payment. Please contact support.");
              });
          }
          // product
          else if (modalName === 'eStoreModal') {
            const eStorePAYLOADData = JSON.parse(
              localStorage.getItem("estorePurchased")
            );

            const finalBookingData = {
              ...eStorePAYLOADData,
              TRANSACTION_ID: data.transactionId || slug,
              TRANSACTION_STATUS: "Success",
              PAYMENT_STATUS: "Completed",
              ApplicationType: 'Website'
            };

            axios
              .post(`${BaseUrl}/Estore_order`, finalBookingData)
              .then((res) => {
                if (res?.data?.ID) {
                  localStorage.removeItem("estorePurchased");
                  localStorage.setItem("cartItemCount", "0");
                  window.dispatchEvent(new Event("cartUpdated"));
                }
              })
              .catch((err) => {
                console.error("Booking API Error:", err);
                alert("Booking failed after payment. Please contact support.");
              });
          }

          else if (modalName === "pujaAtTempleBooking") {
            const pujaAtTempleBookingData = JSON.parse(
              localStorage.getItem("pujaAtTempleBookingData")
            );

            const finalBookingData = {
              ...pujaAtTempleBookingData,
              TRANSACTION_ID: data.transactionId || slug,
              TRANSACTION_STATUS: "Success",
              PAYMENT_STATUS: "Completed",
            };

            axios
              .post(`${BaseUrl}/PoojaAtTemple`, finalBookingData)
              .then((res) => {
                if (res?.data?.ID) {
                  localStorage.removeItem("pujaAtTempleBookingData");
                }
              })
              .catch((err) => {
                console.error("Booking API Error:", err);
                alert("Booking failed after payment. Please contact support.");
              });
          } else if (modalName === "poojaBookingRemaining") {
            const PujaBookingData = JSON.parse(
              localStorage.getItem("PujaBookingData")
            );

            const finalBookingData = {
              ...PujaBookingData,
              TRANSACTION_ID: data.transactionId || slug,
              TRANSACTION_STATUS: "Success",
              PAYMENT_STATUS: "Completed",
            };

            axios
              .post(
                `${BaseUrl}/UpdatePaymentStatus?TYPE=Pandit`,
                finalBookingData
              )
              .then((res) => {
                if (res?.data?.ID) {
                  localStorage.removeItem("PujaBookingData");
                }
              })
              .catch((err) => {
                console.error("Booking API Error:", err);
                alert("Booking failed after payment. Please contact support.");
              });
          } else if (modalName === "dailyPujaBookingRemaining") {
            const dailyPujaBookingData = JSON.parse(
              localStorage.getItem("dailyPujaBookingData")
            );

            const finalBookingData = {
              ...dailyPujaBookingData,
              TRANSACTION_ID: data.transactionId || slug,
              TRANSACTION_STATUS: "Success",
              PAYMENT_STATUS: "Completed",
            };

            axios
              .post(
                `${BaseUrl}/UpdatePaymentStatus?TYPE=DailyPuja`,
                finalBookingData
              )
              .then((res) => {
                if (res?.data?.ID) {
                  localStorage.removeItem("dailyPujaBookingData");
                }
              })
              .catch((err) => {
                console.error("Booking API Error:", err);
                alert("Booking failed after payment. Please contact support.");
              });
          } else if (modalName === "estore") {
            const estorePayload = JSON.parse(
              localStorage.getItem("estorePayload")
            ); // Replace with actual payload source

            axios
              .post(`${BaseUrl}/Estore_order`, estorePayload)
              .then((response) => {
                if (response.data.ResponseMessage === "Order Success.") {
                  localStorage.setItem("cartItemCount", "0");
                  window.dispatchEvent(new Event("cartUpdated"));
                }
              })
              .catch((err) => {
                console.error("Estore API Error:", err);
                alert("Estore order failed. Please contact support.");
              });
          }
        } else if (data.state === "FAILED") {
          setStatus("failed");
          setPaymentData(data);
        } else {
          setStatus("pending");
          setPaymentData(data);
        }
      } catch (error) {
        console.error("Payment Status API Error:", error);
        setStatus("error");
      }
    };

    fetchPaymentStatus();
  }, [slug]);

  const getStatusColor = () => {
    switch (status) {
      case "completed":
        return "text-success";
      case "failed":
        return "text-danger";
      case "pending":
        return "text-warning";
      default:
        return "text-secondary";
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className=" shadow-sm w-100" style={{ maxWidth: "600px" }}>
        <div className="">
          <h3 className="card-title text-center mb-4">Payment Status</h3>

          {/* Show loading */}
          {status === "loading" && (
            <p className="text-center">Checking payment status...</p>
          )}

          {/* Show error if API fails */}
          {status === "error" && (
            <p className="text-danger text-center">
              Failed to fetch payment status.
            </p>
          )}

          {/* Show failed UI */}
          {status === "failed" && (
            <div className="text-center">
              <img
                src="/assets/payment-failed.png" // make sure this image exists in public/assets
                alt="Payment Failed"
                style={{ width: "150px", marginBottom: "20px" }}
              />
              <h4 className="text-danger">Payment Failed</h4>
              <p>
                Your payment could not be completed. If the amount was deducted,
                please contact support.
              </p>
              <button
                className="btn btn-secondary mt-3"
                onClick={() => navigate("/")}
              >
                Go to Home
              </button>
            </div>
          )}

          {/* Show success/pending details */}
          {(status === "completed" || status === "pending") && paymentData && (
            <>
              <div className={`h5 text-center fw-bold ${getStatusColor()}`}>
                {paymentData.state}
              </div>

              <div className="error-404">
                <div className="">
                  <div>
                    <img
                      src={placeholderImg}
                      alt="404"
                      className="error-404__image"
                    />
                  </div>

                  <h3 className="error-404__text">
                    Thank you for your order!{" "}
                  </h3>
                  <div className="error-404__btns">
                    <button
                      style={{ background: "#8f3246" }}
                      onClick={() => {
                        navigate("/");
                      }}
                      class="btn text-white mt-3 me-2"
                    >
                      {" "}
                      Go To Home
                    </button>
                    {modalName && (
                      <button
                        style={{ background: "#8f3246" }}
                        class="btn text-white mt-3 ms-2"
                        onClick={() => {
                          let route = "/my-order";

                          switch (modalName) {
                            case "pujaBook":
                              route = "/my-order-puja-booking";
                              break;
                            case "poojaBookingRemaining":
                              route = "/my-order-puja-booking";
                              break;
                            case "dailyPujaBooking":
                              route = "/my-order-daily-Booking";
                              break;
                            case "darshanBooking":
                              route = "/my-order-darshan-Booking";
                              break;
                            case "pujaAtTemple":
                              route = "/my-order-puja-At-Temple";
                              break;
                            case "parsadBooking":
                              route = "/prasad-order";
                              break;
                            case "templeBooking":
                              route = "/my-order-darshan-Booking";
                              break;
                            case "pujaAtTempleBooking":
                              route = "/my-order-puja-At-Temple";
                              break;
                            case "prasadBookingModal":
                              route = "/prasad-order";
                              break;
                            case "dailyPujaBookingRemaining":
                              route = "/my-order-daily-Booking";

                            default:
                              route = "/my-order";
                          }

                          navigate(route);
                        }}
                      >
                        My Orders
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="mt-4 d-flex justify-content-between">
                <button
                  className="btn btn-secondary"
                  onClick={() => navigate("/")}
                >
                  Home
                </button>

                {modalName && (
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      let route = "/my-order";

                      switch (modalName) {
                        case "pujaBook":
                          route = "/my-order-puja-booking";
                          break;
                        case "poojaBookingRemaining":
                          route = "/my-order-puja-booking";
                          break;
                        case "dailyPujaBooking":
                          route = "/my-order-daily-Booking";
                          break;
                        case "darshanBooking":
                          route = "/my-order-darshan-Booking";
                          break;
                        case "pujaAtTemple":
                          route = "/my-order-puja-At-Temple";
                          break;
                        case "parsadBooking":
                          route = "/prasad-order";
                          break;
                        case "templeBooking":
                          route = "/my-order-darshan-Booking";
                          break;
                        case "dailyPujaBookingRemaining":
                          route = "/my-order-daily-Booking";

                        default:
                          route = "/my-order";
                      }

                      navigate(route);
                    }}
                  >
                    My Orders
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckPaymentStatus;
